<!--
  Карточка пользователя в сайдбаре — ЧИСТАЯ ВЬЮХА: данные приходят пропами,
  ничего сама не грузит. Кто грузит: бекофис — SidebarUser.vue (контейнер со
  сторами), дашборд проекта — свой партиал (там в плашке подписка, а не роль).
-->
<template>
  <div
    class="flex-shrink-0 w-100"
    :class="{
      'pd-micro': !stateSidebar,
      'pd-small': stateSidebar,
      'br-t-1px br-subtle': divider,
    }"
  >
    <!-- Скелетон повторяет саму карточку: та же подложка, паддинги и раскладка
         (аватар + строки текста), чтобы при загрузке ничего не прыгало. -->
    <div
      v-if="loading"
      class="w-100 radius-small bg-base flex flex-nowrap"
      :class="stateSidebar ? 'pd-thin flex-v-center' : 'w-max-semi aspect-1x1 flex-center'"
    >
      <span class="skeleton w-2r h-2r radius-small flex-child-none"></span>
      <div v-if="stateSidebar" class="flex-child-1 w-min-0 mn-l-thin o-hidden flex flex-column gap-thin">
        <span class="skeleton skeleton--text"></span>
        <span class="skeleton skeleton--badge"></span>
      </div>
    </div>

    <!-- User card -->
    <router-link
      v-else-if="user?._id"
      :to="to || `/backoffice/users/${user._id}`"
      class="ease-quint-out flex w-100 radius-small cursor-pointer flex-nowrap"
      :class="[
        // Свёрнутое состояние — квадрат по канону Navigation (w-max-semi + aspect-1x1
        // внутри контейнера pd-micro), чтобы карточка встала в ту же сетку, что пункты меню.
        stateSidebar ? 'pd-thin flex-v-center' : 'w-100 w-max-semi aspect-1x1 flex-center',
        // Подложка и ховер как у кнопки переключения темы в футере сайдбара:
        // цвет панели страницы + ховер на шаг светлее (токены theme-aware).
        'bg-base hover:bg-card'
      ]"
    >
      <span class="flex-child-none w-2r h-2r flex flex-center">
        <img
          v-if="user.profile?.photo"
          :src="(FILE_SERVER_URL || '') + user.profile.photo"
          class="radius-small bg-base object-fit-cover w-2r h-2r"
        />
        <PlaceholderUserpic
          v-else
          class="radius-small w-2r h-2r"
        />
      </span>

      <!-- Колонка ДОЛЖНА ужиматься: flex-child-1 + w-min-0 (без min-width:0
           флекс-элемент не сжимается меньше своего текста и длинный емейл
           распирает сайдбар), тогда truncate обрезает многоточием. -->
      <div
        v-if="stateSidebar"
        class="flex-child-1 w-min-0 mn-l-thin o-hidden flex flex-column gap-thin"
      >
        <!-- Имя/логин — обычным мелким текстом, плашка снизу — то, что передал
             контейнер: роль в бекофисе, тариф подписки в дашборде.
             Фоллбек вместо голого Anonymous: у юзера без профиля — логин/контакт входа. -->
        <!-- data-volatile: имя и почта у каждого тестового аккаунта свои — снимок e2e их скрывает. -->
        <p data-volatile class="footnote truncate">{{ user.profile?.name || user.username || user.email || user.phone || 'Anonymous' }}</p>
        <p v-if="user.email && (user.profile?.name || user.username)" data-volatile class="footnote t-muted truncate">{{ user.email }}</p>
        <div v-if="badges.length" class="flex flex-nowrap gap-thin o-hidden">
          <span
            v-for="(badge, index) in badges"
            :key="index"
            class="badge truncate w-min-0"
          >
            {{ badge }}
          </span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script setup>
  import PlaceholderUserpic from '@martyrs/src/modules/icons/placeholders/PlaceholderUserpic.vue'

  defineProps({
    theme: {
      type: String,
      default: 'light'
    },
    stateSidebar: {
      type: Boolean,
      default: false
    },
    // Пользователь целиком (auth/users store) — грузит контейнер.
    user: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    // Плашки под именем: роли, тариф подписки — уже готовыми строками.
    badges: {
      type: Array,
      default: () => []
    },
    // Куда ведёт карточка; дефолт — бекофисный профиль (легаси-поведение).
    to: {
      type: [String, Object],
      default: null
    },
    // Верхний дивайдер нужен, когда карточка стоит футером сайдбара;
    // в шапке сайдбара его отключают пропом.
    divider: {
      type: Boolean,
      default: true
    }
  })
</script>
